import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

export interface StripPicture {
  url: string;
}

/**
 * Bande de photos scrollable horizontalement avec flèches gauche/droite.
 * Les flèches ne s'affichent que si les photos débordent réellement du cadre.
 * Chaque instance gère son propre état de scroll (pas de flag partagé), ce qui
 * permet de l'utiliser plusieurs fois pour un même device (aperçu + accordéon).
 */
@Component({
  selector: 'app-picture-strip',
  standalone: false,
  templateUrl: './picture-strip.component.html',
  styleUrl: './picture-strip.component.scss',
})
export class PictureStripComponent {
  @Input() public pictures: StripPicture[] = [];
  @Input() public alt = '';
  @Output() public pictureClick = new EventEmitter<string>();

  @ViewChild('track') private trackRef?: ElementRef<HTMLElement>;

  public canScrollLeft = false;
  public canScrollRight = false;

  public scroll(direction: 'left' | 'right'): void {
    const track = this.trackRef?.nativeElement;
    if (!track) {
      return;
    }
    const amount = track.clientWidth * 0.8;
    track.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  }

  // Recalculé au scroll et au chargement des images (leur largeur conditionne
  // le débordement) pour piloter l'affichage des flèches.
  public updateArrows(): void {
    const track = this.trackRef?.nativeElement;
    if (!track) {
      return;
    }
    this.canScrollLeft = track.scrollLeft > 1;
    this.canScrollRight =
      track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
  }
}
